export default __webpack_public_path__ + "static/media/EfficiencyImg.b845b9d3.jpg";